import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';

import { SharedProductCarouselItem } from './SharedProductCarouselItem';
import { BarHeader } from 'dibs-elements/exports/BarHeader';

import styles from './SharedProductCarousel.scss';

export const SharedProductCarouselComponent = ({ collectionsModules, showOverlay, isClient }) => {
    const { title, itemsConnection } = collectionsModules;
    const edges = get(itemsConnection, 'edges') || [];

    return (
        <div className={styles.wrapper}>
            {title && <BarHeader title={title} />}
            {edges.length > 0 && (
                <div className={styles.itemsWrapper}>
                    {edges.map(edge => (
                        <SharedProductCarouselItem
                            key={edge.node.serviceId}
                            edge={edge}
                            showOverlay={showOverlay}
                            isClient={isClient}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

SharedProductCarouselComponent.propTypes = {
    collectionsModules: PropTypes.object.isRequired,
    showOverlay: PropTypes.bool,
    isClient: PropTypes.bool.isRequired,
};

export const SharedProductCarousel = createFragmentContainer(SharedProductCarouselComponent, {
    collectionsModules: graphql`
        fragment SharedProductCarousel_collectionsModules on CollectionsModulesPhotoCarousel {
            title
            itemsConnection {
                edges {
                    ...SharedProductCarouselItem_edge
                    node {
                        serviceId
                    }
                }
            }
        }
    `,
});
